import { Pill } from '@dsny/dsny-component-library';
import styled from 'styled-components';

export const ArtistPillWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
  gap: 8px;
`;

export const TruncatingPill = styled(Pill)`
  max-width: 100%;
  min-width: 0;

  > span:last-child {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > span:not(:last-child) {
    flex-shrink: 0;
  }
`;
